// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as FontAwesomeIcon$LiteracyplanetClientSxEntry from "../FontAwesomeIcon.res.mjs";
import * as SecondaryComponents$LiteracyplanetClientSxEntry from "./SecondaryComponents.res.mjs";

function SecondaryNavBar$InitialsIcon(props) {
  var r = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.marginTop,
          32
        ],
        tl: {
          hd: [
            Css.height,
            60
          ],
          tl: /* [] */0
        }
      });
  var css = Css.style(/* [] */0);
  var className = Css.merge({
        hd: css,
        tl: {
          hd: r,
          tl: {
            hd: "InitialsIcon",
            tl: /* [] */0
          }
        }
      });
  return React.createElement("div", {
              className: className
            }, props.children);
}

var InitialsIcon = {
  make: SecondaryNavBar$InitialsIcon
};

function SecondaryNavBar$TeacherModeWidget(props) {
  var screenReaderLabel = props.screenReaderLabel;
  var r = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.height,
          20
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.borderBottomRightRadius,
            6
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.padding,
              10
            ],
            tl: {
              hd: [
                Css.gridGap,
                6
              ],
              tl: {
                hd: [
                  Theme$LiteracyplanetClientFlags.borderRightWidth,
                  2
                ],
                tl: {
                  hd: [
                    Theme$LiteracyplanetClientFlags.borderBottomWidth,
                    2
                  ],
                  tl: {
                    hd: [
                      Theme$LiteracyplanetClientFlags.fontSize,
                      12
                    ],
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      });
  var css = Css.style({
        hd: Css.textDecoration(Css.none),
        tl: {
          hd: Css.fontFamily({
                NAME: "custom",
                VAL: "museo-sans-rounded"
              }),
          tl: /* [] */0
        }
      });
  var responsive = Css.merge({
        hd: css,
        tl: {
          hd: r,
          tl: {
            hd: "TeacherModeWidget",
            tl: /* [] */0
          }
        }
      });
  var iconSize = Css.merge({
        hd: Theme$LiteracyplanetClientFlags.resize({
              hd: [
                Css.width,
                12
              ],
              tl: /* [] */0
            }),
        tl: /* [] */0
      });
  return React.createElement("button", {
              "aria-label": screenReaderLabel,
              className: TailwindMerge.twMerge("fixed left-0 top-0 z-10 my-auto flex flex-row items-center border-white bg-[#0dadf7] font-sx font-bold text-white shadow-md shadow-black/50 hover:cursor-pointer hover:bg-[#0979ac]", responsive),
              title: screenReaderLabel,
              onClick: props.onClick
            }, React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                  iconName: "left-to-bracket",
                  className: TailwindMerge.twMerge("text-white", iconSize),
                  ariaHidden: true
                }), React.createElement("div", {
                  "aria-hidden": true
                }, "Teacher Mode"));
}

var TeacherModeWidget = {
  make: SecondaryNavBar$TeacherModeWidget
};

function SecondaryNavBar(props) {
  var onClickMyWords = props.onClickMyWords;
  var onClickIntrepizine = props.onClickIntrepizine;
  var onClickShop = props.onClickShop;
  var onClickArcade = props.onClickArcade;
  var onClickCollections = props.onClickCollections;
  var onClickMissions = props.onClickMissions;
  var onClickWordFlyers = props.onClickWordFlyers;
  var match = React.useState(function () {
        return false;
      });
  var setSubnavOpen = match[1];
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var wordFlyersAvailable = hasFlag("CanAccessWordFlyers") && hasFlag("StudentHasWordFlyers");
  return React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.HeaderBackground.make, {
              children: null
            }, props.showTeacherModeWidget ? React.createElement(SecondaryNavBar$TeacherModeWidget, {
                    screenReaderLabel: "Return to Teacher Mode",
                    onClick: props.onClickTeacherMode
                  }) : null, React.createElement("div", {
                  className: "relative"
                }, React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.HeaderPanel.make, {
                      children: null
                    }, React.createElement(SecondaryNavBar$InitialsIcon, {
                          children: props.menu
                        }), React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.MissionsSlimHeaderItem.make, {
                          highlight: props.highlightMissions,
                          onClick: (function (param) {
                              onClickMissions();
                              setSubnavOpen(function (param) {
                                    return false;
                                  });
                            })
                        }), wordFlyersAvailable ? React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.WordFlyersSlimHeaderItem.make, {
                            highlight: false,
                            onClick: (function (param) {
                                onClickWordFlyers();
                                setSubnavOpen(function (param) {
                                      return false;
                                    });
                              })
                          }) : null, React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.MyWordsSlimHeaderItem.make, {
                          highlight: props.highlightMyWords,
                          onClick: (function (param) {
                              onClickMyWords();
                              setSubnavOpen(function (param) {
                                    return false;
                                  });
                            }),
                          lock: props.lockMyWords
                        }), React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.IntrepizineSlimHeaderItem.make, {
                          highlight: props.highlightLibrary,
                          onClick: (function (param) {
                              onClickIntrepizine();
                            }),
                          lock: props.lockLibrary
                        }), React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.CollectionsSlimHeaderItem.make, {
                          highlight: props.highlightCollections,
                          notificationCount: props.collectionNotificationCount,
                          onClick: (function (param) {
                              onClickCollections();
                              setSubnavOpen(function (param) {
                                    return false;
                                  });
                            }),
                          lock: props.lockCollections
                        }), props.showArcade ? React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.ArcadeSlimHeaderItem.make, {
                            highlight: props.highlightArcade,
                            onClick: (function (param) {
                                onClickArcade();
                                setSubnavOpen(function (param) {
                                      return false;
                                    });
                              }),
                            lock: props.lockArcade
                          }) : null, React.createElement(SecondaryComponents$LiteracyplanetClientSxEntry.AvatarSlimHeaderItem.make, {
                          highlight: false,
                          onClick: (function (param) {
                              onClickShop();
                              setSubnavOpen(function (param) {
                                    return false;
                                  });
                            }),
                          lock: props.lockShop
                        }))));
}

var ratio = Theme$LiteracyplanetClientFlags.resize;

var make = SecondaryNavBar;

export {
  ratio ,
  InitialsIcon ,
  TeacherModeWidget ,
  make ,
}
/* Css Not a pure module */
